module.exports = __webpack_public_path__ + "img/bio-minder.52aed70d.png";